const STORAGE_KEY = 'beacon_home_friends_plans'

// Session-scoped on purpose: a filter remembered across launches could leave
// someone who turned it off once never seeing their crew's plans again.
export function readFriendsPlans(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) !== '0'
  } catch {
    return true
  }
}

export function writeFriendsPlans(on: boolean) {
  try {
    sessionStorage.setItem(STORAGE_KEY, on ? '1' : '0')
  } catch {
    // Not remembered; the choice still applies until Home unmounts.
  }
}
